"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const keautils_1 = require("keautils");
const filtrarOrdenar_1 = require("../simpleGrid/filtrarOrdenar");
const react_rxk_1 = require("react-rxk");
const spinner_1 = require("../../spinner");
/**Convierte un GridColumn a un FiltroComponentColumna */
function gridColumnToFiltroColumn(data, value) {
    const getData = (item) => value.cell(item).data;
    return {
        filterComponent: filtrarOrdenar_1.getFiltro(data, getData, value.filter).component,
        title: value.title,
        key: value.key || value.title
    };
}
exports.gridColumnToFiltroColumn = gridColumnToFiltroColumn;
class FiltroComponentNoRx extends React.PureComponent {
    render() {
        return React.createElement(this.props.FilterComponent, Object.assign({}, this.props));
    }
}
/**Componente que dibuja un filtro */
const FiltroComp = react_rxk_1.componentToRx(FiltroComponentNoRx, undefined, undefined, { FilterComponent: { initial: spinner_1.Spinner } });
/**Componente que muestra todos los filtros de un grid */
class FiltroListComponent extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.handleOnChange = (value, key) => {
            const props = this.props;
            const nuevo = Object.assign({}, props.value, { [key]: { datos: value } });
            props.onChange(nuevo);
        };
        this.handleQuitar = (key) => {
            const props = this.props;
            props.onChange(keautils_1.filterObject(props.value, (x, k) => k != key));
        };
    }
    render() {
        const props = this.props;
        const comp = React.createElement("div", null,
            React.createElement("div", { className: "row" }, Object.keys(props.value).map((key) => React.createElement("div", { className: "col-md-4", key: key },
                React.createElement(FiltroComp, { items: props.items, value: props.value[key].datos, column: props.columnas[key].key, titulo: props.columnas[key].title, FilterComponent: props.columnas[key].filterComponent, onChange: (value) => this.handleOnChange(value, key), onQuitar: () => this.handleQuitar(key) })))));
        return comp;
    }
}
exports.FiltroListComponent = FiltroListComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/filtros.js
// module id = 2221
// module chunks = 0